function hueAngleToColor(hueAngle, saturationMultiplier = 1, lightnessMultiplier = 1) {
  const saturation = (0.6 + 0.4 * Math.max(0, Math.cos(hueAngle))) * saturationMultiplier;
  const lightness = (0.5 + 0.2 * Math.max(0, Math.cos(hueAngle + Math.PI * 2 / 3))) * lightnessMultiplier;
  return `hsl(${hueAngle * 180 / Math.PI}deg, ${Math.round(100 * saturation)}%, ${Math.round(100 * lightness)}%)`;
}
let previousPatternContext;
let previousPatternRatio;
let previousPatternScale;
let patternCanvas;
let patternContext;
let patternScale = 1;
let pattern;
function colorToCanvasFill(color, c, originX, originY, scale) {
  if (!Array.isArray(color))
    return color;
  const ratio = window.devicePixelRatio || 1;
  if (previousPatternContext !== c || previousPatternRatio !== ratio || previousPatternScale !== scale) {
    const s = Math.round(64 * ratio) / 64;
    patternScale = scale;
    patternScale = Math.log2(patternScale);
    patternScale -= Math.floor(patternScale);
    const t1 = patternScale;
    const t8 = Math.min(1, 8 * t1);
    patternScale = 2 ** patternScale;
    const lineWidth = 8 * Math.SQRT2 / patternScale;
    previousPatternContext = c;
    previousPatternRatio = ratio;
    previousPatternScale = scale;
    patternCanvas ||= document.createElement("canvas");
    patternContext ||= patternCanvas.getContext("2d");
    patternCanvas.width = patternCanvas.height = Math.round(64 * s);
    patternContext.scale(s, s);
    patternContext.fillStyle = color[0];
    patternContext.fillRect(0, 0, 64, 64);
    patternContext.globalAlpha = 0.25;
    patternContext.fillStyle = color[1];
    patternContext.fillRect(0, 0, 64, 64);
    patternContext.globalAlpha = 0.67;
    patternContext.strokeStyle = color[1];
    patternContext.beginPath();
    for (let i = 0; i <= 64; i += 16) {
      patternContext.moveTo(i - 32, i + 32);
      patternContext.lineTo(i + 32, i - 32);
    }
    patternContext.lineWidth = lineWidth * (1 - (t8 - t1) / 2);
    patternContext.stroke();
    if (t8 + t1 > 0) {
      patternContext.beginPath();
      for (let i = 8; i < 64; i += 16) {
        patternContext.moveTo(i - 32, i + 32);
        patternContext.lineTo(i + 32, i - 32);
      }
      patternContext.lineWidth = lineWidth * (t8 + t1) / 2;
      patternContext.stroke();
    }
    pattern = c.createPattern(patternCanvas, "repeat");
    patternScale /= s;
  }
  originX /= 64 * patternScale * ratio;
  originX -= Math.floor(originX);
  originX *= 64 * patternScale * ratio;
  pattern.setTransform(new DOMMatrix([
    patternScale,
    0,
    0,
    patternScale,
    originX,
    originY
  ]));
  return pattern;
}
function colorToCssBackground(color) {
  if (Array.isArray(color)) {
    return `url('data:image/svg+xml,<svg width="26" height="26" xmlns="http://www.w3.org/2000/svg"><rect width="26" height="26" fill="${color[0]}"/><rect width="26" height="26" fill="${color[1]}" fill-opacity="25%"/><path d="M22.5 -3.5L-3.5 22.5M35.5 9.5L9.5 35.5" stroke="${color[1]}" stroke-opacity="67%" stroke-width="9.19239"/></svg>')`;
  }
  return color;
}
function createColorGetterFromMap(plain) {
  return (node) => node.id ? plain[node.id] || node.color : node.color;
}
function createColorGetterSpectrum(tree, saturationMultiplier = 1, lightnessMultiplier = 1) {
  const colorMapping = {};
  assignColorsByDirectory(colorMapping, tree, 0, Math.PI * 2, saturationMultiplier, lightnessMultiplier);
  return createColorGetterFromMap(colorMapping);
}
function assignColorsByDirectory(colorMapping, node, startAngle, sweepAngle, saturationMultiplier = 1, lightnessMultiplier = 1) {
  const totalBytes = node.size;
  colorMapping[node.id] = hueAngleToColor(startAngle + sweepAngle / 2, saturationMultiplier, lightnessMultiplier);
  for (const child of node.children) {
    const childSweepAngle = child.size / totalBytes * sweepAngle;
    assignColorsByDirectory(colorMapping, child, startAngle, childSweepAngle, saturationMultiplier, lightnessMultiplier);
    startAngle += childSweepAngle;
  }
}

const urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
function randomStr(size = 16, dict = urlAlphabet) {
  let id = "";
  let i = size;
  const len = dict.length;
  while (i--)
    id += dict[Math.random() * len | 0];
  return id;
}

function normalizeTreeNode(node, parent, sort = (a, b) => b.size - a.size) {
  if (node.__nanovis)
    return node;
  const normalized = {
    ...node
  };
  normalized.id ||= randomStr();
  normalized.parent ||= parent;
  normalized.children ||= [];
  if (normalized.sizeSelf == null && normalized.size != null && normalized.children.length === 0)
    normalized.sizeSelf = normalized.size;
  else
    normalized.sizeSelf ||= 0;
  normalized.children = (normalized.children || []).map((child) => normalizeTreeNode(child, normalized, sort));
  normalized.size ||= normalized.children.reduce((acc, child) => acc + child.size, 0) + normalized.sizeSelf;
  if (sort)
    normalized.children.sort(sort);
  Object.defineProperty(normalized, "__nanovis", { enumerable: false, value: true });
  return normalized;
}
function getTreeMaxDepth(node) {
  if (node.children.length === 0)
    return 1;
  return Math.max(...node.children.map((child) => getTreeMaxDepth(child))) + 1;
}

const isFirefox = /\bFirefox\//.test(navigator.userAgent);
let numberFormat;
function formatInteger(value) {
  return numberFormat ? numberFormat.format(value) : `${value}`;
}
function now() {
  return (window.performance || Date).now();
}
function formatNumberWithDecimal(value) {
  const parts = value.toFixed(1).split(".", 2);
  return `${formatInteger(+parts[0])}.${parts[1]}`;
}
function bytesToText(bytes) {
  if (bytes === 1)
    return "1 byte";
  if (bytes < 1024)
    return `${formatInteger(bytes)} bytes`;
  if (bytes < 1024 * 1024)
    return `${formatNumberWithDecimal(bytes / 1024)} kb`;
  if (bytes < 1024 * 1024 * 1024)
    return `${formatNumberWithDecimal(bytes / (1024 * 1024))} mb`;
  return `${formatNumberWithDecimal(bytes / (1024 * 1024 * 1024))} gb`;
}
function strokeRectWithFirefoxBugWorkaround(c, color, x, y, w, h) {
  if (isFirefox) {
    const lineWidth = c.lineWidth;
    const halfWidth = lineWidth / 2;
    c.fillStyle = color;
    c.fillRect(x - halfWidth, y - halfWidth, w + lineWidth, lineWidth);
    c.fillRect(x - halfWidth, y + halfWidth, lineWidth, h - lineWidth);
    c.fillRect(x - halfWidth, y + h - halfWidth, w + lineWidth, lineWidth);
    c.fillRect(x + w - halfWidth, y + halfWidth, lineWidth, h - lineWidth);
    return;
  }
  c.strokeStyle = color;
  c.strokeRect(x, y, w, h);
}
function useWheelEventListener(listener) {
  window.addEventListener("wheel", listener, { passive: false });
  return () => window.removeEventListener("wheel", listener);
}
function useResizeEventListener(listener) {
  window.addEventListener("resize", listener);
  return () => window.removeEventListener("resize", listener);
}
try {
  numberFormat = new Intl.NumberFormat();
} catch {
}

export { useResizeEventListener as a, colorToCanvasFill as b, createColorGetterSpectrum as c, bytesToText as d, colorToCssBackground as e, createColorGetterFromMap as f, getTreeMaxDepth as g, hueAngleToColor as h, normalizeTreeNode as i, now as n, strokeRectWithFirefoxBugWorkaround as s, useWheelEventListener as u };
